import { View } from "react-native";
import Touchable from "src/components/Touchable";
import { Text } from "src/swsh-native";

const GatheringFilterSortSectionHeader = ({
	label,
	numSelected,
	numTotal,
	showSeeAll,
	handleSeeAll,
}: {
	label: string;
	numSelected?: number;
	numTotal?: number;
	showSeeAll?: boolean;
	handleSeeAll?: () => void;
}) => {
	return (
		<View style={{ flexDirection: "row", paddingBottom: 12, justifyContent: "space-between" }}>
			<View testID="FilterSortHeader-Label" style={{ flexDirection: "row" }}>
				<Text xs semibold>
					{label}
				</Text>
				{numSelected && numSelected > 0 ? (
					<Text testID="FilterSortHeader-NumSelected" xs semibold color="TextLight">
						{numSelected ? ` (${numSelected} selected)` : ""}
					</Text>
				) : null}
			</View>
			{showSeeAll && (
				<Touchable testID="FilterSortHeader-SeeAll" onPress={handleSeeAll} hitSlop={15}>
					<Text xs semibold style={{ textDecorationLine: "underline" }}>
						{/* The potentially blank space after "See all" is intentional. It looks better! */}
						{`See all ${numTotal ? numTotal : ""}`}
					</Text>
				</Touchable>
			)}
		</View>
	);
};

export default GatheringFilterSortSectionHeader;
